import { confirmAlert } from "react-confirm-alert";
import firebase, { fire, auth } from "../../firebase/index";
import {
  deploymentEnvironment,
  customLog,
  monthNames,
} from "../../variables/Variables";

const db = firebase.database();

const getToday = (callback) => {
  const today = new Date();

  let todayMonth = today.getMonth();

  callback(today.getDate() + "-" + monthNames[todayMonth]);
};

const cancelSub = async (data, callback) => {
  const subId = data.subId;
  const userId = data.uid;
  const language = data.language;

  const dataToPost = {
    subId: subId,
    uid: userId,
    language: language,
  };

  let url = "";

  if (deploymentEnvironment) {
    url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/cancelLiveSubscription";
    customLog("Live Environment @ SubscriptionManagementHelper");
  } else {
    url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/cancelTestSubscription";
    customLog("Test Environment @ SubscriptionManagementHelper");
  }

  let response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(dataToPost),
  });

  if (response !== null) {
    callback(response);
  }
};

const showConfirmAlert = (title, message, buttons) => {
  confirmAlert({
    title: title,
    message: message,
    buttons: buttons,
  });
};

const getCustomerIdAndName = (callback) => {
  db.ref("groupAccounts/" + auth.currentUser.uid + "/payment")
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        const snapshotDetails = snapshot.val();
        const data = {
          status: "ok",
          cusId: snapshotDetails.stripeCustomerId,
        };
        callback(data);
      } else {
        callback(false);
      }
    });
};

const updateGroupAccounts = (cardName, cardAddr, cardLastfour, cardExp) => {
  db.ref("groupAccounts/" + auth.currentUser.uid + "/payment").update({
    cardName: cardName,
    billingAddr: cardAddr,
    cardLastFourDigit: cardLastfour,
    cardExp: cardExp,
  });
};

const createPlanSubscription = async (dataToPass, callback) => {
  let url = "";
  if (deploymentEnvironment) {
    url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/newUserSubscriptionTrialLIVE3DS";
    customLog("Live Environment @ StripeBtn");
  } else {
    url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/newUserSubscriptionTrialTEST3DS";
    customLog("Test Environment @ StripeBtn");
  }

  await fetch(url, {
    method: "POST",
    body: JSON.stringify(dataToPass),
  })
    .then(async (response) => {
      customLog(response); //resposne from firebase;
      let returnedVal = await response.json();
      callback(returnedVal);
    })
    .catch((err) => {
      customLog(err);
      callback(false);
    });
};

const updateExistingGroupAccounts = async (dataToUpdate, callback) => {
  //Update group account, have subscribed before
  const fireDbGroupAccounts = fire
    .database()
    .ref("groupAccounts")
    .child(auth.currentUser.uid);

  fireDbGroupAccounts.child("payment").update(dataToUpdate);

  callback(true);
};

const updateUserDetails = async (paidDate, customerId, planSelected) => {
  //try
  fire
    .database()
    .ref("registeredIndustrialUsersOnPlatform/" + auth.currentUser.uid)
    .update(
      {
        stripeBillingCycleStart: paidDate,
        stripeID: customerId,
        stripePaidPlan: planSelected,
      },
      function(error) {
        if (error) {
          customLog(error);
        } else {
          // window.location.reload();
          setTimeout(() => {
            window.location.href = "/plans";
          }, 3000);
        }
      }
    );
};

export {
  getToday,
  cancelSub,
  showConfirmAlert,
  getCustomerIdAndName,
  updateGroupAccounts,
  createPlanSubscription,
  updateExistingGroupAccounts,
  updateUserDetails,
};
